import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DeleteMemberRequest, GetTripMembersResponse } from './interfaces';
import { HttpClient } from '@angular/common/http';
import { getTripId } from '../../../shared';

@Injectable()
export class PeopleApi {
  #httpClient = inject(HttpClient);
  #tripId = getTripId();

  public getMembers(tripId = this.#tripId): Observable<GetTripMembersResponse> {
    return this.#httpClient.get<GetTripMembersResponse>(`trip/members?tripId=${tripId}`);
  }

  public leaveTrip(tripId: string): Observable<void> {
    return this.#httpClient.post<void>(`trip/leave`, { tripId });
  }

  public removeMember({ tripId, memberId }: DeleteMemberRequest): Observable<void> {
    return this.#httpClient.post<void>(`trip/remove-member`, { tripId, memberId });
  }
}
